import { SchemeEditController } from './schemes/edit/scheme-edit.controller';
import { SchemeController } from './schemes/schemes.controller';
import * as UserRoutes from './user.routes';
import { IControllerConstructor } from 'angular';

export const initialise = () => {
  angular.module('app.user', [
    'app.layout',
    
  ])
    .controller('SchemeController', <IControllerConstructor>SchemeController)
    .controller('SchemeEditController', <IControllerConstructor>SchemeEditController)
    .controller('SchemeController', <IControllerConstructor>SchemeController);

  UserRoutes.initialise();
};
